/**
 * Created by richard on 7/14/14.
 */
var vouchersModel = angular.module('vouchersModel', ['schoolModel']);
vouchersModel.factory('VouchersModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory, AbstractModelService){
    var VouchersModel = function(){
        this.endpoint = "/Vouchers";
        this.primaryKey = "Holder";
    }
    VouchersModel.prototype = new SchoolModelFactory();
    VouchersModel.prototype.parent = SchoolModelFactory.prototype;
    VouchersModel.prototype.new = function()
    {
        var voucher = {
            Voucher_Number: '', Ap_Number: '', date_used: '', used: 0, free: '', memo: '',
            paid: 0, paid_date: '0000-00-00', isAlliance: '', isUnitedJewishFederation: ''
        };
        return (this.data.push(voucher)) - 1;
    }
    VouchersModel.prototype.purge = function(id, data, instance)
    {
        var parent = this;
        return AbstractModelService.purge(this.getEndpoint(id) + '/' + data[this.primaryKey], data, instance).then(function(result)
        {
            if (result.data == 1)
            {
                for (var i = 0; i < parent.data.length; i++)
                {
                    if (data[parent.primaryKey] == parent.data[i][parent.primaryKey])
                        parent.data.splice(i, 1);
                }

            }
            parent.origData = parent.data;
        });
    }

    return VouchersModel;
});


vouchersModel.service('VouchersModelService', function(VouchersModelFactory){
    var vouchersModel = new VouchersModelFactory();
    return vouchersModel;
});


